/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["debug .mat-header-cell {\n    text-align: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tYWluL3dlYmFwcC9zcmMvYXBwL2Zyb2dpcy9kZWJ1Zy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksa0JBQWtCO0FBQ3RCIiwiZmlsZSI6InNyYy9tYWluL3dlYmFwcC9zcmMvYXBwL2Zyb2dpcy9kZWJ1Zy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiZGVidWcgLm1hdC1oZWFkZXItY2VsbCB7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuIl19 */"];
export { styles as styles };
